import TableLayout from "../../../../layout/main/TableLayout";
import { Column, Row } from "../../../../../styles/CommonStyles";
import { TradeTypeBadge } from "../../../../../styles/main/orders";
import { getTradeTypeColor } from "../../../../../core/utils/theme";
import DateTime from "../../../../common/utils/DateTime";
import CopyText from "../../../../common/utils/CopyText";


const UserActivityTable = ({ data }) => {

    const { data: sessions } = data

    return (
        <TableLayout
            headers={headers}
            cs={CS}
            hasPagination={false}
            data={data}
        >
            {sessions?.data?.map((session, idx) => (
                <Row cs={CS} index={idx} >
                    <Column>
                        {idx + 1}
                    </Column>
                    <Column>
                        {session.ip}
                    </Column>
                    <Column>
                        {`${session.extra?.deviceName}-${session?.extra?.deviceVersion}-${session?.extra?.appVersion}`}
                    </Column>
                    <Column>
                        <CopyText text={`${session.token}`} />
                    </Column>
                    <Column>
                        <TradeTypeBadge color={getTradeTypeColor('limit')}>
                            {session.platform}
                        </TradeTypeBadge>
                    </Column>
                    <Column center>
                        <DateTime dt={session.createdAt} />
                    </Column>
                </Row>
            ))}
        </TableLayout>
    )
}


const CS = '5% 25% 20% 20% 20% 10%'
const headers = [
    'ip', 'browser', 'platform', 'token', 'date'
]

export default UserActivityTable
